import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { compose } from 'recompose';
import FetchOnMount from '../hoc/FetchOnMount';
import Choose from './components/Choose';
import { fetchShop } from '../shops/actions';
import { generateUrlString } from '../utils/helpers';
import { getAllowBookWithAnyBarber } from '../shops/selectors';


const mapStateToProps = (state, ownProps) => ({
  allowBookWithAnyBarber: getAllowBookWithAnyBarber(state, ownProps.params.shopRoute),
  generateUrlString: urlPattern =>
    generateUrlString({ shopRoute: ownProps.params.shopRoute }, urlPattern),
});

const mapDispatchToProps = (dispatch, ownProps) => bindActionCreators({
  fetchData: fetchShop.bind(null, ownProps.params.shopRoute),
}, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  FetchOnMount,
)(Choose);



// WEBPACK FOOTER //
// ./src/app/dynamicBooking/Choose.jsx